import Typography from 'helpers/fonts';
import { useSmallScreen } from 'helpers/isSmallScreen';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUiState } from 'state/ui-state/ui-state';
import { LoadingSpinner } from '../loading-spinner/loading-spinner';
import { formatMoney } from 'helpers/util';

export const ViewRunningTotalFooter: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { bom } = useUiState();
  const isSmallScreen = useSmallScreen();
  return (
    <div
      style={{
        height: isSmallScreen ? '42px' : 'auto',
        width: '100%',
        display: 'flex',
        padding: '20px',
        borderTop: '2px solid white',
        justifyContent: 'flex-end',
        alignItems: 'center',
        backgroundColor: Theme['@grey-lightest'],
      }}
    >
      <Typography style={{ marginRight: '20px' }} styleid={4}>
        {t('runningTotal.runningTotal')}
      </Typography>
      <Typography style={{ fontWeight: 'bold' }} styleid={4}>
        {bom?.totalPrice ? `${formatMoney(bom?.totalPrice)}` : <LoadingSpinner style={{maxHeight: 24}}/>}
      </Typography>
    </div>
  );
};
